import request from '../untils/request';

export const activityManageListApi = params => {
  return request({
    url: '/activity/activity-manage/index',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};

export const activityDeleteApi = params => {
  return request({
    url: '/activity/activity-manage/delete',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};

export const activityDetailApi = params => {
  return request({
    url: '/activity/activity-manage/detail',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};

export const activitySelectedGoodsApi = params => {
  return request({
    url: '/activity/activity-manage/goods-list',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};

export const activityGoodsListApi = params => {
  return request({
    url: '/activity/activity-manage/goods-select',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};

export const activityUpdateApi = params => {
  return request({
    url: '/activity/activity-manage/update',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};

export const activityCreateApi = params => {
  return request({
    url: '/activity/activity-manage/create',
    authCode: 'ACTIVITY-MANAGE',
    params,
  });
};
